import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { FiltersSkin, FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

interface FilterPropsType {
    skin?: FiltersSkinType;
    isActive?: boolean;
    isDisabled?: boolean;
    isMultipleLine?: boolean;
    variant?: DefaultComponentVariantType | null;
}

export const FiltersWrapper = styled('div', { label: 'FiltersWrapper' })`
    position: relative;
    overflow-y: auto;
`;

export const GradientOverlay = withConfig(theme => styled('div', { label: 'GradientOverlay' })`
    background-image: ${`linear-gradient(to right,${theme.star.filtersColors.wrapper.bgColorSecondary},transparent)`};
    height: 32px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 56px;
    z-index: ${theme.star.zIndexGlobal.above};
`);

const setColors = (theme: EmotionTheme, isActive?: boolean, skin?: FiltersSkinType): SerializedStyles => {
    if (skin === FiltersSkin.PRIMARY) {
        if (isActive === true) {
            return css`
                background: ${theme.star.filtersColors.primary.bgColor};
                border: 1px solid ${theme.star.filtersColors.primary.borderColor};
                color: ${theme.star.filtersColors.primary.txtColorSecondary};
            `;
        }
        return css`
            background: ${theme.star.filtersColors.primary.bgColorSecondary};
            border: 1px solid ${theme.star.filtersColors.primary.borderColorSecondary};
            color: ${theme.star.filtersColors.primary.txtColor};
        `;
    }

    if (skin === FiltersSkin.SECONDARY) {
        if (isActive === true) {
            return css`
                background: ${theme.star.filtersColors.secondary.bgColor};
                border: 1px solid ${theme.star.filtersColors.secondary.borderColor};
                color: ${theme.star.filtersColors.secondary.txtColorSecondary};
            `;
        }
        return css`
            background: ${theme.star.filtersColors.secondary.bgColorSecondary};
            border: 1px solid ${theme.star.filtersColors.secondary.borderColorSecondary};
            color: ${theme.star.filtersColors.secondary.txtColor};
        `;
    }

    if (skin === FiltersSkin.TERTIARY) {
        if (isActive === true) {
            return css`
                background: ${theme.star.filtersColors.tertiary.bgColor};
                border: 1px solid ${theme.star.filtersColors.tertiary.borderColor};
                color: ${theme.star.filtersColors.tertiary.txtColorSecondary};
            `;
        }
        return css`
            background: ${theme.star.filtersColors.tertiary.bgColorSecondary};
            border: 1px solid ${theme.star.filtersColors.tertiary.borderColorSecondary};
            color: ${theme.star.filtersColors.tertiary.txtColor};
        `;
    }

    return css`
        color: red;
        background-color: blue;
    `;
};

export const Filter = withConfig(theme => styled('button', { label: 'Filter' })<FilterPropsType>`
    ${({ isActive, skin }): SerializedStyles => setColors(theme, isActive, skin)};
    align-items: center;
    align-self: flex-start;
    border-radius: ${theme.star.filtersColors.radius};
    cursor: ${({ isDisabled }): string => isDisabled === true ? 'not-allowed' : 'pointer'};
    display: inline-block;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3334;
    margin: ${({ isMultipleLine }): string => isMultipleLine === true ? '0 8px 8px 0' : '0 8px 0 0'};
    height: 32px;
    padding: 0 12px;
    user-select: none;
    white-space: nowrap;
    &:last-of-type {
        margin-right: 0;
    }
`);
